var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { Box, TextField, Button, Typography, CircularProgress, Link } from '@mui/material';
import { useAuth } from './AuthContext';
import { useNotification } from '../context/NotificationContext';
import { PasswordResetForm } from './PasswordResetForm';
export const EmailLoginForm = ({ onError }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const { signInWithEmail } = useAuth();
    const { showNotification } = useNotification();
    // Show error notification when there's an error
    const prevErrorRef = useRef(null);
    useEffect(() => {
        if (error && error !== prevErrorRef.current) {
            prevErrorRef.current = error;
            showNotification({
                message: error,
                severity: 'error'
            });
            // Also call the onError callback if provided
            if (onError) {
                onError(new Error(error));
            }
        }
    }, [error, showNotification, onError]);
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError(null);
        if (!email || !password) {
            setError('Please enter both email and password');
            return;
        }
        try {
            setLoading(true);
            yield signInWithEmail(email, password);
            // Don't call onSuccess immediately - wait for auth state to propagate
            // The auth provider will handle the loading state
        }
        catch (err) {
            setError(err.message || 'Failed to login');
            setLoading(false); // Only set loading to false if there's an error
        }
    });
    const handlePasswordResetSuccess = () => {
        // After successful password reset email sent, we can optionally do something here
        // For now, we'll just leave the reset form visible with the success message
    };
    if (showPasswordReset) {
        return (_jsx(PasswordResetForm, { onSuccess: handlePasswordResetSuccess, onError: onError, onCancel: () => setShowPasswordReset(false) }));
    }
    return (_jsxs(Box, { component: "form", onSubmit: handleSubmit, noValidate: true, children: [_jsx(Typography, { variant: "h6", component: "h2", gutterBottom: true, children: "Email Login" }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "email", label: "Email Address", name: "email", autoComplete: "email", autoFocus: true, value: email, onChange: (e) => setEmail(e.target.value), disabled: loading }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "password", label: "Password", type: "password", id: "password", autoComplete: "current-password", value: password, onChange: (e) => setPassword(e.target.value), disabled: loading }), _jsx(Box, { sx: { display: 'flex', justifyContent: 'flex-end', mt: 1, mb: 2 }, children: _jsx(Link, { component: "button", type: "button", variant: "body2", onClick: () => setShowPasswordReset(true), sx: { cursor: 'pointer' }, children: "Forgot password?" }) }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 1, mb: 2 }, disabled: loading, children: loading ? _jsx(CircularProgress, { size: 24 }) : 'Sign In' })] }));
};
